function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9 0C4.02891 0 0 3.27305 0 7.3125C0 9.05625 0.752344 10.6523 2.00391 11.9074C1.56445 13.6793 0.0949219 15.2578 0.0773438 15.2754C0 15.3562 -0.0210937 15.4758 0.0246094 15.5813C0.0703125 15.6867 0.16875 15.75 0.28125 15.75C2.61211 15.75 4.35938 14.632 5.22422 13.943C6.37383 14.3754 7.65 14.625 9 14.625C13.9711 14.625 18 11.352 18 7.3125C18 3.27305 13.9711 0 9 0Z",
  fill: "#274160"
});

var SvgMessageBubble = function SvgMessageBubble(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMessageBubble, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/messageBubble.3e98d9f5.svg";
export { ForwardRef as ReactComponent };